export default {
  expiredTime: 29.6 * 24 * 60 * 60 * 1000,
  path: "/",
  domain: window.location.hostname,
  secure: false,
}
